import { render, staticRenderFns } from "./AccountConfirmation.vue?vue&type=template&id=8c711b5e&scoped=true&"
import script from "./AccountConfirmation.vue?vue&type=script&lang=js&"
export * from "./AccountConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AccountConfirmation.vue?vue&type=style&index=0&id=8c711b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c711b5e",
  null
  
)

export default component.exports